(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["memo-paris-case-study"] && !Shopify.designMode) return;
  try {
    
function initMemo(scope) {
 scope.querySelectorAll('.memo-motion').forEach(wrap => {
  const video = wrap.querySelector('video'); const button = wrap.querySelector('button');
  if (!video || !button || button.dataset.ready) return;
  button.dataset.ready = 'true';
  const sync = () => { button.textContent = video.paused ? button.dataset.play : button.dataset.pause; button.setAttribute('aria-label', button.textContent); };
  button.addEventListener('click', () => { if (video.paused) video.play().catch(sync); else video.pause(); });
  video.addEventListener('play', sync); video.addEventListener('pause', sync);
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) { video.autoplay = false; video.pause(); }
  sync();
 });
}
initMemo(document);
document.addEventListener('shopify:section:load', event => initMemo(event.target));

  } catch(e) { console.error(e); }
})();
})();
